exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.border-light[data-v-812f4a32] {border: 1px solid darkgray}\n", ""]);

// exports
